<template>
  <div class="generalEstimate">
    <div class="reportBasic-subTitle">
      {{ $tc('lang.FabricReport.Brief_Findings') }}
    </div>
    <div class="generalEstimate-con">
      <!-- <div> -->
      <a-form>
        <!-- <a-form-item
          label="总体结论"
          :label-col="{ span: 3 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-radio-group v-model="details.ireportConclusion">
            <a-radio value="1">通过</a-radio>
            <a-radio value="2">待定</a-radio>
            <a-radio value="3">不通过</a-radio>
          </a-radio-group>
        </a-form-item> -->
        <!-- <a-form-item
          label="检验标准"
          :label-col="{ span: 3 }"
          :wrapper-col="{ span: 10 }"
        >
          <a-input v-model="dataForm.biao"></a-input>
        </a-form-item> -->
        <a-form-item
          :label="$tc('lang.FabricReport.Brief_Findings')"
          :label-col="{ span: 3 }"
          :wrapper-col="{ span: 15 }"
        >
          <div class="spanGroup">
            <span class="span1">{{
              $tc('lang.FabricReport.A_Bulk_Summary')
            }}</span>
            <span class="span2">
              <a-radio-group v-model="fabricDetails.freportIsload">
                <a-radio value="1">{{
                  $tc('lang.FabricReport.Conform')
                }}</a-radio>
                <a-radio value="2">{{
                  $tc('lang.FabricReport.Pending')
                }}</a-radio>
                <a-radio value="3">{{
                  $tc('lang.FabricReport.Not_Conform')
                }}</a-radio>
              </a-radio-group>
            </span>
            <span class="span3">
              <a-input
                :placeholder="$tc('lang.ReportsDetail.Description')"
                v-model="fabricDetails.freportLoad"
              ></a-input>
            </span>
          </div>
          <div class="spanGroup">
            <span class="span1">{{
              $tc('lang.FabricReport.B_Packing_Information')
            }}</span>
            <span class="span2">
              <a-radio-group v-model="fabricDetails.freportIspack">
                <a-radio value="1">{{
                  $tc('lang.FabricReport.Conform')
                }}</a-radio>
                <a-radio value="2">{{
                  $tc('lang.FabricReport.Pending')
                }}</a-radio>
                <a-radio value="3">{{
                  $tc('lang.FabricReport.Not_Conform')
                }}</a-radio>
              </a-radio-group>
            </span>
            <span class="span3">
              <a-input
                :placeholder="$tc('lang.ReportsDetail.Description')"
                v-model="fabricDetails.freportPack"
              ></a-input>
            </span>
          </div>
          <div class="spanGroup">
            <span class="span1">{{
              $tc('lang.FabricReport.C_Workmanship')
            }}</span>
            <span class="span2">
              <a-radio-group v-model="fabricDetails.freportIsproductdetail">
                <a-radio value="1">{{
                  $tc('lang.FabricReport.Conform')
                }}</a-radio>
                <a-radio value="2">{{
                  $tc('lang.FabricReport.Pending')
                }}</a-radio>
                <a-radio value="3">{{
                  $tc('lang.FabricReport.Not_Conform')
                }}</a-radio>
              </a-radio-group>
            </span>
            <span class="span3">
              <a-input
                :placeholder="$tc('lang.ReportsDetail.Description')"
                v-model="fabricDetails.freportProductdetail"
              ></a-input>
            </span>
          </div>
          <div class="spanGroup">
            <span class="span1">{{
              $tc('lang.FabricReport.D_Product_Width')
            }}</span>
            <span class="span2">
              <a-radio-group v-model="fabricDetails.freportIstruck">
                <a-radio value="1">{{
                  $tc('lang.FabricReport.Conform')
                }}</a-radio>
                <a-radio value="2">{{
                  $tc('lang.FabricReport.Pending')
                }}</a-radio>
                <a-radio value="3">{{
                  $tc('lang.FabricReport.Not_Conform')
                }}</a-radio>
              </a-radio-group>
            </span>
            <span class="span3">
              <a-input
                :placeholder="$tc('lang.ReportsDetail.Description')"
                v-model="fabricDetails.freportTruck"
              ></a-input>
            </span>
          </div>
          <div class="spanGroup">
            <span class="span1">{{
              $tc('lang.FabricReport.E_Data_measurement_Field_test')
            }}</span>
            <span class="span2">
              <a-radio-group v-model="fabricDetails.freportIsprocess">
                <a-radio value="1">{{
                  $tc('lang.FabricReport.Conform')
                }}</a-radio>
                <a-radio value="2">{{
                  $tc('lang.FabricReport.Pending')
                }}</a-radio>
                <a-radio value="3">{{
                  $tc('lang.FabricReport.Not_Conform')
                }}</a-radio>
              </a-radio-group>
            </span>
            <span class="span3">
              <a-input
                :placeholder="$tc('lang.ReportsDetail.Description')"
                v-model="fabricDetails.freportProcess"
              ></a-input>
            </span>
          </div>
          <div class="spanGroup">
            <span class="span1">{{
              $tc('lang.FabricReport.F_Defects_List')
            }}</span>
            <span class="span2">
              <a-radio-group v-model="fabricDetails.freportIsseal">
                <a-radio value="1">{{
                  $tc('lang.FabricReport.Conform')
                }}</a-radio>
                <a-radio value="2">{{
                  $tc('lang.FabricReport.Pending')
                }}</a-radio>
                <a-radio value="3">{{
                  $tc('lang.FabricReport.Not_Conform')
                }}</a-radio>
              </a-radio-group>
            </span>
            <span class="span3">
              <a-input
                :placeholder="$tc('lang.ReportsDetail.Description')"
                v-model="fabricDetails.freportSeal"
              ></a-input>
            </span>
          </div>
        </a-form-item>
        <a-form-item
          :label="$tc('lang.FabricReport.Remarks')"
          :label-col="{ span: 3 }"
          :wrapper-col="{ span: 10 }"
        >
          <a-textarea
            v-model="fabricDetails.freportConclusion"
            style="resize: none; height: 100px;"
            :placeholder="$tc('lang.ReportsDetail.Description')"
          ></a-textarea>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      fabricDetails: JSON.parse(
        JSON.stringify(this.$store.state.report.fabricDetails),
      ),
      id: this.$route.query.id,
    };
  },
  computed: {
    data: {
      get() {
        return this.$store.state.report.fabricDetails;
      },
      set(val) {
        this.$store.commit('report/save', { fabricDetails: val });
      },
    },
  },
  methods: {
    save() {
      this.$http
        .post('/hzwmj/workorder-fabricreport/saveOrUpdateLoadigreport', {
          freportId: this.fabricDetails.freportId,
          modelType: '11',

          freportIsload: this.fabricDetails.freportIsload,
          freportLoad: this.fabricDetails.freportLoad,
          freportIspack: this.fabricDetails.freportIspack,
          freportPack: this.fabricDetails.freportPack,
          freportIsproductdetail: this.fabricDetails.freportIsproductdetail,
          freportProductdetail: this.fabricDetails.freportProductdetail,
          freportIstruck: this.fabricDetails.freportIstruck,
          freportTruck: this.fabricDetails.freportTruck,
          freportIsprocess: this.fabricDetails.freportIsprocess,
          freportProcess: this.fabricDetails.freportProcess,
          freportIsseal: this.fabricDetails.freportIsseal,
          freportSeal: this.fabricDetails.freportSeal,
          freportConclusion: this.fabricDetails.freportConclusion,
        })
        .then(data => {
          if (data) {
            this.$message.success('保存成功');
            // this.$store.commit('report/save', { details: data });
            this.getDetail();
          } else {
            this.$message.error('保存失败');
          }
        })
        .catch(() => {
          this.$message.error('保存失败');
        });
    },
    getDetail() {
      this.$http
        .post('/hzwmj/workorder-loadigreport/getData', {
          id: this.id,
        })
        .then(data => {
          if (data) {
            this.data = data;
          } else {
            this.data = {};
          }
        })
        .catch(() => {
          this.data = {};
        });
    },
  },
};
</script>
<style lang="less">
.generalEstimate {
  .generalEstimate-con {
    display: flex;
    form {
      flex-grow: 1;
      .ant-form-item-label {
        text-align: left;
        padding-left: 20px;
      }
      .spanGroup {
        display: flex;
        .span1 {
          width: 130px;
        }
        .span2 {
          margin: 0 40px;
        }
        .span3 {
          flex-grow: 1;
        }
      }
    }
  }
}
</style>
